import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { MIXPANEL_VALUES } from '@/components/layout/navigation/constants';
import { env } from '@/env';
import { useFlagStore } from '@/stores/flag';
import { useIdentityStore } from '@/stores/identity';

export function handleZendesk() {
  window.open(env.zendeskResourceCenterUrl, '_blank');
}

export function useUtilityNavigationMenu() {
  const identityStore = useIdentityStore();

  const flagStore = useFlagStore();

  const route = useRoute();

  const canAccessResourceCenter = computed(() => !!env.zendeskResourceCenterUrl);

  const firstName = computed(() => identityStore.identity?.first_name);

  const utilityNavigationMenuItems = computed(() => [
    {
      icon: 'legacy-settings',
      iconHoverClassList:
        'fill-icon-subtle group-hover:!fill-icon-primary group-focus:!fill-icon-primary group-active:!fill-icon-primary',
      label: 'Settings',
      route: {
        name: 'settings',
        params: { brandLabel: identityStore.currentBrandLabel },
      },
      tracking: MIXPANEL_VALUES.UTILITY_MENU.SETTINGS,
      visible: true,
      inactive: route.name === 'settings.billing',
    },
    {
      icon: 'legacy-billing',
      iconHoverClassList:
        'fill-icon-subtle group-hover:!fill-icon-primary group-focus:!fill-icon-primary group-active:!fill-icon-primary',
      label: 'Billing and Plan',
      route: {
        name: 'settings.billing',
        params: { brandLabel: identityStore.currentBrandLabel },
      },
      tracking: MIXPANEL_VALUES.UTILITY_MENU.BILLING,
      visible:
        identityStore.isCurrentBrandRoleAdmin &&
        !(flagStore.ready && flagStore.flags.hideBillingAndPlans),
    },
    {
      icon: 'legacy-question',
      iconHoverClassList:
        'fill-icon-subtle group-hover:!fill-icon-primary group-focus:!fill-icon-primary group-active:!fill-icon-primary',
      label: 'Resource Center',
      command: handleZendesk,
      tracking: MIXPANEL_VALUES.UTILITY_MENU.RESOURCE_CENTER,
      visible:
        canAccessResourceCenter.value && !(flagStore.ready && flagStore.flags.hideBillingAndPlans),
    },
    {
      icon: 'legacy-logout',
      iconHoverClassList:
        'fill-icon-subtle group-hover:!fill-icon-primary group-focus:!fill-icon-primary group-active:!fill-icon-primary',
      label: 'Log Out',
      route: { name: 'auth.logout' },
      tracking: MIXPANEL_VALUES.UTILITY_MENU.LOGOUT,
      visible: true,
    },
  ]);

  const visibleUtilityNavigationMenuItems = computed(() =>
    utilityNavigationMenuItems.value.filter((item) => item.visible),
  );

  return {
    firstName,
    visibleUtilityNavigationMenuItems,
  };
}
